export const IndustryEnum = Object.freeze({
    BCM: "Bcm",
    FMCG: "Fmcg",
});

export const BCMSubIndustryEnum = Object.freeze({
    CEMENT: "Cement",
    STEEL: "Steel",
    PAINT_AND_HARDWARE: "Paint & Hardware",
    TILES_AND_ADHESIVE: "Tiles & Adhesive",
    PLYWOOD: "Plywood",
    ELECTRICALS_SUPPLIERS: "Electrical Suppliers",
});
export const BCMTurnoverEnum = Object.freeze({
    BELOW_5_LACS : "Less than 5 lacs",
    BETWEEN_5_AND_25_LACS : "5 lacs - 25 lacs",
    BETWEEN_25_AND_50_LACS : "25 lacs - 50 lacs",
    BETWEEN_50_AND_75_LACS : "50 lacs - 75 lacs",
    ABOVE_75_LACS : "75 lacs - 1 Cr.+"
});

export const FMCGSubIndustryEnum = Object.freeze({
    PACKAGED_GOODS: "Packaged Goods",
    FROZEN_GOODS: "Frozen Goods",
    BEVERAGES: "Beverages",
    BEAUTY_AND_PERSONAL_CARE: "Beauty & Personal Care",
    DAIRY_PRODUCTS: "Dairy Products",
    BAKERY_PRODUCTS: "Bakery Products",
});

export const FMCGBrandNumbersEnum = Object.freeze({
    BELOW_10: "Less than 10",
    BETWEEN_10_AND_25: "10-25",
    BETWEEN_25_AND_50: "25-50",
    ABOVE_50: "More than 50",
});

export const FMCGTurnoverEnum = Object.freeze({
  BELOW_5_LACS: "Less than 5 lacs",
  BETWEEN_5_AND_25_LACS: "5 lacs-25 lacs",
  BETWEEN_25_AND_100_LACS: "25 lacs-100 lacs",
  ABOVE_100_LACS: "Above 100 lacs",
});

export const FMCGStoreTypeEnum = Object.freeze({
    SELF_SERVICE_STORE: "Self Service Store",
    KIRANA_STORE: "Kirana Store",
    WHOLESALERS: "Wholesalers",
    BAKERY_STORE: "Bakery Store",
    MASALA_STORE: "Masala Store",
    CHEMIST_STORE: "Chemist Store",
});

export const YesNoEnum = Object.freeze({
	YES: 'Yes',
	NO: 'No',
});

export const PreferredLanguageEnum = Object.freeze({
	ENGLISH: 'English',
	HINDI: 'Hindi',
	OTHER: 'Other',
});

export const RecHolidayTypeEnum = Object.freeze({
	DESERT: 'Desert',
	TEMPLES: 'Temples',
	MOUNTAINS: 'Mountains',
	ADVENTURE: 'Adventure',
	FOOD_NIGHTLIFE: 'Food & Nightlife',
	BEACH: 'Beach',
});

export const MaritalStatusEnum = Object.freeze({
	MARRIED: 'Married',
	SINGLE: 'Single',
	PREFER_NOT_TO_SAY: 'Prefer not to say',
});

export const MaritalSpouseHelpEnum = Object.freeze({
	HOME_MAKER: 'Home Maker',
	HELPING_IN_BUSINESS: 'Helping in Business',
	WORKING_PROFESSIONAL: 'Working Professional',
});
export const NEXTGEN = Object.freeze([
    { label: 'Yes, Definitely!', value: true },
    { label: "No, I don't think so", value: false },
]);